var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronsRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88929 3.3L8.71071 8.3C9.09643 8.7 9.09643 9.3 8.71071 9.7L3.88929 14.7C3.69643 14.9 3.50357 15 3.21429 15C2.925 15 2.73214 14.9 2.53929 14.7C2.15357 14.3 2.15357 13.7 2.53929 13.3L6.68571 9L2.53929 4.7C2.15357 4.3 2.15357 3.7 2.53929 3.3C2.925 2.9 3.50357 2.9 3.88929 3.3ZM10.6393 14.7L15.4607 9.7C15.8464 9.3 15.8464 8.7 15.4607 8.3L10.6393 3.3C10.2536 2.9 9.675 2.9 9.28929 3.3C8.90357 3.7 8.90357 4.3 9.28929 4.7L13.4357 9L9.28929 13.3C8.90357 13.7 8.90357 14.3 9.28929 14.7C9.48214 14.9 9.675 15 9.96429 15C10.2536 15 10.4464 14.9 10.6393 14.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_882_17987",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 14,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88929 3.3L8.71071 8.3C9.09643 8.7 9.09643 9.3 8.71071 9.7L3.88929 14.7C3.69643 14.9 3.50357 15 3.21429 15C2.925 15 2.73214 14.9 2.53929 14.7C2.15357 14.3 2.15357 13.7 2.53929 13.3L6.68571 9L2.53929 4.7C2.15357 4.3 2.15357 3.7 2.53929 3.3C2.925 2.9 3.50357 2.9 3.88929 3.3ZM10.6393 14.7L15.4607 9.7C15.8464 9.3 15.8464 8.7 15.4607 8.3L10.6393 3.3C10.2536 2.9 9.675 2.9 9.28929 3.3C8.90357 3.7 8.90357 4.3 9.28929 4.7L13.4357 9L9.28929 13.3C8.90357 13.7 8.90357 14.3 9.28929 14.7C9.48214 14.9 9.675 15 9.96429 15C10.2536 15 10.4464 14.9 10.6393 14.7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_882_17987)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsRight);
export default __webpack_public_path__ + "static/media/chevrons-right.2acbd3a025f8291d60482cf371814f86.svg";
export { ForwardRef as ReactComponent };